
import ApiService from '../base/api_service';

export const getBalanceReport = async (accessToken, params) => {
    try {
        const response = await ApiService.get('/balance-report', {
            params: params,
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}

export const getBalanceReportChart = async (accessToken, params) => {
    try {
        const response = await ApiService.get('/balance-report/chart', {
            params: params,
            headers: {
                Authorization: accessToken,
                'Content-Type': 'application/json'
            }
        })

        return response

    } catch (error) {
        return error.response;
    }
}
